import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCarSide, FaUserTie, FaCarAlt, FaShuttleVan } from "react-icons/fa";

function ServiceSection() {
    const { t } = useTranslation();
    const [selectedItem, setSelectedItem] = useState(null);

    const serviceItems = [
        {
            title: t("rent_daily_weekley"),
            desc: t("desc_rent_daily_weekley"),
            icon: <FaCarSide className="text-4xl" />,
        },
        {
            title: t("driver_pro"),
            desc: t("desc_driver_pro"),
            icon: <FaUserTie className="text-4xl" />,
        },
        {
            title: t("units"),
            desc: t("desc_units"),
            icon: <FaCarAlt className="text-4xl" />,
        },
        {
            title: t("ready_to_airport"),
            desc: t("desc_ready_to_airport"),
            icon: <FaShuttleVan className="text-4xl" />,
        },
    ];

    return (
        <section
            id="layanan"
            className="py-16 "
        >
            {/*bg-gradient-to-br  from-[#347433] to-green-800 text-white*/}
            <div className="max-w-7xl mx-auto px-4">
                <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12">
                    {t("info_service")}
                </h2>

                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8">
                    {serviceItems.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => setSelectedItem(item)}
                            className="cursor-pointer bg-white bg-opacity-10 hover:bg-opacity-20 backdrop-blur-sm rounded-xl p-6 text-center shadow-md transition duration-300"
                        >
                            <div className="flex justify-center mb-4">{item.icon}</div>
                            <h3 className="text-lg font-semibold">{item.title}</h3>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal */}
            {selectedItem && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-6 text-gray-800 relative">
                        <button
                            onClick={() => setSelectedItem(null)}
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
                        >
                            &times;
                        </button>
                        <div className="flex justify-center mb-4 text-green-700 text-5xl">
                            {selectedItem.icon}
                        </div>
                        <h3 className="text-2xl font-bold text-center mb-4">
                            {selectedItem.title}
                        </h3>
                        <p className="text-center text-gray-600">{selectedItem.desc}</p>
                    </div>
                </div>
            )}
        </section>
    );
}

export default ServiceSection;